import { useMemo } from "react";
import clsx from "clsx";
import styles from "./styles.module.scss";
import { motion } from "framer-motion";
import { iconArrow } from "../../../assets/images";

function CardEvents({ index, item, classCustom, showContent }) {
  const variantSlider = useMemo(
    () => ({
      offScreen: { x: 50, opacity: 0 },
      onScreen: {
        x: 0,
        opacity: 1,
        transition: {
          type: "spring",
          bounce: 0.4,
          duration: 1.5,
          delay: (index + 1) * 0.25,
        },
      },
    }),
    [index]
  );

  return (
    <motion.div
      variants={variantSlider}
      initial="offScreen"
      whileInView={showContent ? "onScreen" : "offScreen"}
      className={clsx("border", styles.cardEvent, classCustom)}
    >
      <div
        className={clsx(
          "w-full mx-auto relative flex flex-col",
          styles.imgContainer
        )}
      >
        <img src={item?.img} alt={`img-${item?.title}`} />
      </div>
      <div className={clsx("p-4 flex-1 flex flex-col", styles.content)}>
        <h4 className="headline-remo text-xl lg:text-3xl">{item?.title}</h4>
        <a href="#" className="mt-2 cursor-pointer flex items-center">
          <p className="lg:text-xl">View event</p>
          <div className="ml-2 flex items-center">
            <img src={iconArrow} alt="icon-arrow" style={{ width: 24 }} />
          </div>
        </a>
      </div>
    </motion.div>
  );
}

export default CardEvents;
